import { Grid, Paper } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import GoogleReCaptcha from "../../components/GoogleReCaptcha";
import RxButton from "../../components/RxButton";
import RxDialog from "../../components/RxDialog";
import { RxDialogState } from "../../components/RxDialog/RxDialog";
import RxTextField from "../../components/RxTextField";
import RxTypography from "../../components/RxTypography";
import api from "../../config/AxiosConfig";
import { SuccessResponseDTO } from "../../constants/CommonObject";
import styles from "./ResetPasswordPage.module.css";
import ResetPasswordPageValidation from "./ResetPasswordPageValidation";

const ResetPasswordPage = () => {
	const history = useHistory();
	const { email, code }: any = useParams();
	const [dialogState, setDialogState] = useState<RxDialogState>({
		isOpen: false,
	} as RxDialogState);
	const [googleReCaptchaToken, setGoogleReCaptchaToken] = useState<string>();
	const siteKey = useSelector((state: any) => state.recaptcha.siteKey);

	const [validationPasswordMessage, setValidationPasswordMessage] =
		useState<string>("");

	const formik = useFormik({
		initialValues: {
			email: (email as string) ?? "",
			password: "",
			passwordConfirm: "",
			code: code,
		},
		validationSchema: ResetPasswordPageValidation,
		validateOnBlur: true,
		validateOnChange: true,
		onSubmit: () => {
			handleSubmit();
		},
	});

	function handleSubmit() {
		if (googleReCaptchaToken !== undefined) {
			api.put(
				`/1/users/${formik.values.email}/reset-password/${formik.values.code}`,
				{
					password: formik.values.password,
					captcha: googleReCaptchaToken,
				}
			)
				.then((response: SuccessResponseDTO) => {
					setDialogState({
						isOpen: true,
						title: "Bilgilendirme",
						message: response.responseValue,
						status: "info",
					});
				})
				.catch((error: any) => {
					setDialogState({
						isOpen: true,
						title: "Hata",
						message:
							error.response?.data.code +
							" - " +
							error.response?.data.message +
							"\r\nLütfen daha sonra tekrar deneyiniz.",
						status: "error",
					});
				});
		}
	}

	useEffect(() => {
		handleSubmit();
	}, [googleReCaptchaToken]); // eslint-disable-line

	const checkPasswordValidation = async (passwordString: string) => {
		const result: SuccessResponseDTO = await api.post(
			"/1/users/check-password",
			{
				password: passwordString,
			}
		);
		setValidationPasswordMessage(
			result.responseValue === "Başarılı" ? "" : result.responseValue
		);
	};

	return (
		<Paper className={styles.mainPaper}>
			<form onSubmit={formik.handleSubmit}>
				<Grid container direction="row" spacing={3}>
					<Grid item xs={12} sm={12}>
						<Grid container spacing={1}>
							<Grid item xs={12} sm={12}>
								<Grid item xs={12} sm={12}>
									<RxTypography
										variant="h5"
										align="center"
										label={<>Parola Tanımla</>}
									/>
									<RxTypography
										variant="body1"
										align="left"
										label={<>Parolanızı belirleyiniz.</>}
									/>
								</Grid>
							</Grid>
							<Grid item xs={12} sm={12}>
								<Grid container spacing={0}>
									<Grid item xs={12} sm={12}>
										<RxTextField
											required
											fullwidth
											type="password"
											id="password"
											name="password"
											label="Parolanız"
											placeholder="Parolanız"
											onBlur={formik.handleBlur}
											onChange={(event: any) => {
												let value = event?.target.value;
												if (value.length === 0) {
													setValidationPasswordMessage("");
												} else {
													checkPasswordValidation(value);
												}
												formik.setFieldValue("password", value);
											}}
											value={formik.values.password}
											error={
												validationPasswordMessage !== "" ||
												(formik.touched.password &&
													Boolean(formik.errors.password))
											}
											helperText={
												formik.touched.password &&
												formik.errors.password
											}
											helperTextStyle={styles.helperTextStyle}
											inputLabelClassName={styles.inputLabel}
										/>
									</Grid>
									<Grid item xs={12} sm={12}>
										{validationPasswordMessage && (
											<Grid item xs={12} sm={12}>
												<Alert
													icon={false}
													severity="error"
													className={styles.alertStyle}
												>
													{validationPasswordMessage}
												</Alert>
											</Grid>
										)}
									</Grid>
								</Grid>
							</Grid>
							<Grid item xs={12} sm={12}>
								<RxTextField
									fullwidth
									required
									type="password"
									id="passwordConfirm"
									name="passwordConfirm"
									label="Parolanız (Tekrar)"
									placeholder="Parolanız (Tekrar)"
									onBlur={formik.handleBlur}
									onChange={formik.handleChange}
									value={formik.values.passwordConfirm}
									error={
										formik.touched.passwordConfirm &&
										Boolean(formik.errors.passwordConfirm)
									}
									helperText={
										formik.touched.passwordConfirm &&
										formik.errors.passwordConfirm
									}
									helperTextStyle={styles.helperTextStyle}
									inputLabelClassName={styles.inputLabel}
								/>
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs={12} sm={12}>
						<RxButton
							fullWidth
							color={"primary"}
							variant="contained"
							label="Parola Sıfırla"
							type="submit"
							id="submit"
						/>
					</Grid>
				</Grid>
				<GoogleReCaptcha
					siteKey={siteKey}
					setGoogleReCaptchaToken={setGoogleReCaptchaToken}
				/>
			</form>
			{dialogState.isOpen && (
				<RxDialog
					title={dialogState.title}
					status={dialogState.status}
					maxWidth="sm"
					actions={
						<>
							<RxButton
								fullWidth
								label="Tamam"
								color="primary"
								variant="contained"
								onClick={() => {
									setDialogState((prevState: RxDialogState) => {
										return { ...prevState, isOpen: false };
									});
									if (dialogState.status !== "error")
										history.push("/login");
								}}
							/>
						</>
					}
				>
					<RxTypography align="left" label={dialogState.message} />
				</RxDialog>
			)}
		</Paper>
	);
};

export default ResetPasswordPage;
